import React from "react";
import { useNavigation } from "@react-navigation/native";
import { ResponsiveValue } from "@shopify/restyle";
import theme, { Theme } from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { StyleSheet } from "react-native";
import ArrowLeftIcon from "./ArrowLeftIcon";
import { Box } from "./Box/MainBox/MainBox";
import CrossIcon from "./Icons/CrossIcon";
import { MainText } from "./MainText";
import { MainTitle } from "./MainTitle";
import { PressableOpacity } from "./PressableOpacity";

const styles = StyleSheet.create({
  arrow: {
    marginLeft: normalize(-16),
  },
});

export interface IHeaderScreenProps {
  title: string;
  subtitle?: string;
  leftIcon?: boolean;
  rightIcon?: boolean;
  isRightIconArrow?: boolean;
  backIconTestID?: string;
  callbackOnPress?: () => void;
  onPressSubtitle?: () => void;
  subtitleColor?: ResponsiveValue<keyof Theme["colors"], Theme>;
  subtitleVariant?: ResponsiveValue<keyof Theme["textVariants"], Theme>;
}

const HeaderScreen = ({
  title,
  leftIcon,
  rightIcon,
  subtitle,
  backIconTestID,
  isRightIconArrow = false,
  callbackOnPress,
  onPressSubtitle,
  subtitleColor = "brand.500",
  subtitleVariant = "l4-semibold",
}: IHeaderScreenProps) => {
  const navigation = useNavigation();

  const pressedIcon = () => {
    if (!callbackOnPress) {
      navigation.goBack();
    } else {
      callbackOnPress();
    }
  };

  return (
    <Box
      flexDirection="row"
      width="100%"
      alignItems="flex-start"
      marginBottom="sm"
    >
      <Box flexDirection="row" alignItems="center">
        {!!leftIcon && (
          <PressableOpacity
            testID={backIconTestID}
            style={styles.arrow}
            onPress={pressedIcon}
            hitSlop={theme.hitSlop}
          >
            <Box
              justifyContent="center"
              alignItems="center"
              marginRight="sm"
              marginLeft="sm"
            >
              <ArrowLeftIcon
                color={theme.colors["neutral.900"]}
                height={normalize(14)}
                width={normalize(14)}
              />
            </Box>
          </PressableOpacity>
        )}
        <MainTitle numberOfLines={2} variant="l8-bold">
          {title}
        </MainTitle>
      </Box>
      <Box flex={1}>
        <Box maxWidth="90%" flexDirection="column">
          {!!subtitle && (
            <PressableOpacity onPress={onPressSubtitle}>
              <MainText
                textDecorationLine={!!onPressSubtitle ? "underline" : "none"}
                variant={subtitleVariant}
                color={subtitleColor}
                marginTop="xxs"
              >
                {subtitle}
              </MainText>
            </PressableOpacity>
          )}
        </Box>
      </Box>
      <Box justifyContent="flex-end" alignItems="center" marginTop="xxs">
        {!!rightIcon && (
          <PressableOpacity onPress={pressedIcon} hitSlop={theme.hitSlop}>
            {!!isRightIconArrow ? (
              <ArrowLeftIcon
                color={theme.colors["neutral.900"]}
                height={normalize(20)}
                width={normalize(20)}
              />
            ) : (
              <CrossIcon
                color={theme.colors["neutral.900"]}
                height={normalize(24)}
                width={normalize(24)}
              />
            )}
          </PressableOpacity>
        )}
      </Box>
    </Box>
  );
};

export default HeaderScreen;
